import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleAssignment", "departments"]

  connect() {
    this.roleAssignmentTargets.forEach(input => {
      input.addEventListener("change", this.toggleDepartments.bind(this))
      this.toggleDepartments({ target: input })
    })
  }

  toggleDepartments(event) {
    const input = event.target
    const block = input.closest(".client-permissions")
    const departments = block.querySelector(".client-permissions_departments")
    if (!departments) return

    const checkboxes = departments.querySelectorAll('input[type="checkbox"]')

    if (input.value === "hiring_staff" && input.checked) {
      checkboxes.forEach(cb => cb.disabled = false)
    } else {
      checkboxes.forEach(cb => cb.disabled = true)
    }
  }
}
